import React, { useEffect, useState } from "react";
import LogoBar from "../../components/common/logoBar";
import Barcode from "react-barcode";
import { api } from "../../../config";
import { useParams, useNavigate } from "react-router-dom";
import { useWindowSize } from "../../hooks";
import Loading from "../../components/common/loading";

import store from "../../redux/store";
import * as Actions from "../../redux/actions";
import { Modal } from "antd";

const ProductInfo = () => {
  const language = window.ferrero.locale;
  const [isInMyCatalog, setIsInMyCatalog] = useState(null);

  const [product, setProducts] = useState();

  const { catalogoId, categoriaId, marcaId, codeEAN, codeITF } = useParams();

  const navigate = useNavigate();

  useEffect(() => {
    store
      .dispatch(
        Actions.getProductsByITF(
          catalogoId,
          categoriaId,
          marcaId,
          codeEAN,
          codeITF
        )
      )
      .then((data) => {
        const product = data.payload.data.productsByItf;
        setIsInMyCatalog(data.payload.data.isInMyCatalog);
        setProducts(product[0]);
      });
  }, []);

  const size = useWindowSize();

  const {
    unidadescaja,
    pesoneto,
    pesobrutocaja,
    alto,
    ancho,
    largo,
    ean,
    volumen,
    cajas,
    mantos,
    cajasmanto,
    alturapallet,
    pesonetocaja,
    itf,
    titulo,
    code,
    cugrossweight,
    cuheight,
    culength,
    cuwidth,
    pdgrossweight,
  } = { ...product };

  let imageStyle = {
    backgroundImage: `url(${api.media.images}${itf})`,
  };

  const convertToCm = (ele) => {

    return parseFloat(ele / 10).toFixed(1).replace(".", ",");

  }

  const convertGrs = (ele) => {
    const fullNum = ele.replace(".", "").replace(",", "");
    const convertNumber = parseInt(fullNum) / 1000;

    if(convertNumber % 1 === 0) {
      const formatNumber = String(convertNumber).replace(/(?!\..*)(\d)(?=(?:\d{3})+(?:\.|$))/g, '$1.');

      return formatNumber;

    } else {

      return String(convertNumber).replace(".", ",");
      
    }

  }

  return (
    <>
      {!product && <Loading />}

      {product && (
        <>
          <div className="productInfo-logo">
            <LogoBar icon={false} selectedProduct={[product]} />
          </div>

          <div className="productInfo-container">
            <div className="image">
              <div style={imageStyle} />
              <div className="delete-products-button">
                <div className="box">
                  {isInMyCatalog && (
                    <div
                      onClick={(e) => {
                        e.preventDefault();

                        Modal.confirm({
                          title: "Confirmar",
                          content:
                            "Estas seguro/a que quieres eliminar este producto ?",
                          okText: "Eliminar",
                          cancelText: "Cancelar",
                          onOk: () => {
                            store
                              .dispatch(
                                Actions.deleteProducts({
                                  catalogId: catalogoId,
                                  categoryId: categoriaId,
                                  groupId: product.presentacion
                                    .toLowerCase()
                                    .replace(/\s/g, "-"),
                                  ean: product.ean,
                                  itf: product.itf,
                                })
                              )
                              .then(() => {
                                return navigate(`/catalogos/${catalogoId}/${categoriaId}/${marcaId}`);

                              });
                          },
                        });
                      }}
                    >
                      <div className="icon-descargar">
                        <img src="/assets/img/delete-icon.png" />
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>

            {language === "es_ES" ? (
              <div className="content">
                <div className="title">{titulo + " | " + code}</div>
                <div className="codeBar-ean">
                  <span>UNIDAD DE VENTA / CÓDIGO E.A.N.</span>
                  <span>{ean}</span>
                  <Barcode
                    flat={true}
                    value={parseInt(ean).toString() || "00000000"}
                    format={parseInt(ean) && `ean${parseInt(ean).toString().length}`}
                    displayValue={false}
                    height={40}
                    width={size.width <= 428 ? 1 : 3}
                  />
                </div>
                <div className="product-info">
                  <div className="horizontal-line" />
                  <div className="row">
                    <div className="title">peso neto declarado</div>
                    <div className="boxes">
                      <div className="box">
                        <div className="title">UNIDADES CAJAS</div>
                        <div className="data">{unidadescaja}</div>
                      </div>
                      <div className="verical-line" />
                      <div className="box">
                        <div className="title">UNIDAD grs.</div>
                        <div className="data">{pesoneto}</div>
                      </div>
                      <div className="verical-line" />
                      <div className="box">
                        <div className="title">CAJA grs.</div>
                        <div className="data">{convertGrs(pesonetocaja)}</div>
                      </div>
                      <div className="verical-line" />
                      <div className="box">
                        <div className="title">PESO BRUTO CAJA grs.</div>
                        <div className="data">{convertGrs(pesobrutocaja)}</div>
                      </div>
                    </div>
                  </div>

                  <div className="horizontal-line" />
                  <div className="row">
                    <div className="title">medidas embalaje (cm)</div>
                    <div className="boxes">
                      <div className="box">
                        <div className="title">Largo</div>
                        <div className="data">{convertToCm(largo)}</div>
                      </div>
                      <div className="verical-line" />
                      <div className="box">
                        <div className="title">Ancho</div>
                        <div className="data">{convertToCm(ancho)}</div>
                      </div>
                      <div className="verical-line" />
                      <div className="box">
                        <div className="title">Alto</div>
                        <div className="data">{convertToCm(alto)}</div>
                      </div>
                      <div className="verical-line" />
                      <div className="box">
                        <div className="title">
                          Volumen m<sup>3</sup>
                        </div>
                        <div className="data">{volumen.replace(".", ',')}</div>
                      </div>
                    </div>
                  </div>

                  <div className="horizontal-line" />
                  <div className="row">
                    <div className="title">configuración europallet</div>
                    <div className="boxes">
                      <div className="box">
                        <div className="title">Nº cajas</div>
                        <div className="data">{cajas}</div>
                      </div>
                      <div className="verical-line" />
                      <div className="box">
                        <div className="title">Nº mantos</div>
                        <div className="data">{mantos}</div>
                      </div>
                      <div className="verical-line" />
                      <div className="box">
                        <div className="title">Cajas manto</div>
                        <div className="data">{cajasmanto}</div>
                      </div>
                      <div className="verical-line" />
                      <div className="box">
                        <div className="title">Altura pallet (m)</div>
                        <div className="data">{alturapallet}</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ) : (
              <div className="content">
                <div className="title">{titulo + " | " + code}</div>
                <div className="codeBar-ean">
                  <span>CU EAN Code: </span>
                  <span>{ean}</span>
                  <Barcode
                    value={ean || "00000000"}
                    flat={true}
                    format={ean && `ean${ean.length}`}
                    displayValue={false}
                    height={40}
                    width={size.width <= 428 ? 1 : 3}
                  />
                </div>

                <div className="product-info">
                  <div className="row">
                    <div className="horizontal-line" />
                    <div className="title">medidas cu</div>
                    <div className="boxes pt">
                      <div className="box">
                        <div className="title">Unidades Caixas</div>
                        <div className="data">{unidadescaja}</div>
                      </div>
                      <div className="verical-line" />
                      <div className="box">
                        <div className="title">Profundidade (cm)</div>
                        <div className="data">{culength}</div>
                      </div>
                      <div className="verical-line" />
                      <div className="box">
                        <div className="title">Largura Frontal (cm)</div>
                        <div className="data">{cuwidth}</div>
                      </div>
                      <div className="verical-line" />
                      <div className="box">
                        <div className="title">Altura (cm)</div>
                        <div className="data">{cuheight}</div>
                      </div>
                    </div>
                  </div>

                  <div className="row">
                    <div className="boxes pt">
                      <div className="box">
                        <div className="title">Peso Líquido (g)</div>
                        <div className="data">{pesoneto}</div>
                      </div>
                      <div className="verical-line" />
                      <div className="box">
                        <div className="title">Peso Bruto (g)</div>
                        <div className="data">{cugrossweight}</div>
                      </div>
                      <div className="verical-line invisible" />

                      <div className="box"></div>
                      <div className="verical-line invisible" />

                      <div className="box"></div>
                    </div>
                  </div>

                  <div className="horizontal-line" />
                </div>
                <div className="codeBar-ean">
                  <span>ITF.</span>
                  <span>{itf}</span>
                  <Barcode
                    value={parseInt(itf).toString() || "00000000"}
                    flat={true}
                    format={parseInt(itf) && `ean${parseInt(itf).toString().length}`}
                    displayValue={false}
                    height={40}
                    width={size.width <= 428 ? 1 : 3}
                  />
                </div>
                <div className="product-info">
                  <div className="row">
                    <div className="title">medidas embalagem</div>
                    <div className="boxes pt">
                      <div className="box">
                        <div className="title">Profundidade (cm)</div>
                        <div className="data">{convertToCm(largo)}</div>
                      </div>
                      <div className="verical-line" />
                      <div className="box">
                        <div className="title">Largura Frontal (cm)</div>
                        <div className="data">{convertToCm(ancho)}</div>
                      </div>
                      <div className="verical-line" />
                      <div className="box">
                        <div className="title">Altura (cm)</div>
                        <div className="data">{convertToCm(alto)}</div>
                      </div>
                      <div className="verical-line" />
                      <div className="box">
                        <div className="title">
                          Volume m<sup>3</sup>
                        </div>
                        <div className="data">{volumen.replace(".", ',')}</div>
                      </div>
                    </div>
                  </div>

                  <div className="row">
                    <div className="boxes pt">
                      <div className="box">
                        <div className="title">Peso Líquido (g)</div>
                        <div className="data">{convertGrs(pesonetocaja)}</div>
                      </div>
                      <div className="verical-line" />
                      <div className="box">
                        <div className="title">Peso Bruto (g)</div>
                        <div className="data">{convertGrs(pesobrutocaja)}</div>
                      </div>

                      <div className="verical-line invisible" />

                      <div className="box"></div>
                      <div className="verical-line invisible" />

                      <div className="box"></div>
                    </div>
                  </div>

                  <div className="row">
                    <div className="horizontal-line" />
                    <div className="title">configuração europallet</div>
                    <div className="boxes pt">
                      <div className="box">
                        <div className="title">Nº Caixas</div>
                        <div className="data">{cajas}</div>
                      </div>
                      <div className="verical-line" />
                      <div className="box">
                        <div className="title">Nº Camadas</div>
                        <div className="data">{mantos}</div>
                      </div>
                      <div className="verical-line" />
                      <div className="box">
                        <div className="title">Caixas Camada</div>
                        <div className="data">{cajasmanto}</div>
                      </div>
                      <div className="verical-line" />

                      <div className="box">
                        <div className="title">Altura Pallet (m)</div>
                        <div className="data">{alturapallet}</div>
                      </div>
                    </div>
                  </div>

                  <div className="row">
                    <div className="boxes pt">
                      <div className="box">
                        <div className="title">Peso Pallet (kg)</div>
                        <div className="data">{pdgrossweight}</div>
                      </div>
                      <div className="verical-line invisible" />

                      <div className="box"></div>
                      <div className="verical-line invisible" />

                      <div className="box"></div>
                      <div className="verical-line invisible" />

                      <div className="box"></div>
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>
        </>
      )}
    </>
  );
};

export default ProductInfo;
